export default {"src":"/_next/static/media/dog-plus.b1aaabfb.svg","height":812,"width":900};